<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{'bg-success navbar-dark': type === 'default'}"
  >

    <!-- Navbar links -->
    <b-navbar-nav class=" align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler"
             :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    <!-- <h3 class="text-white">Partner:&nbsp;&nbsp;</h3> -->
    <el-select v-if="auth.hasAnyRole([role.Admin])"
        v-model="selectedPartner"
        filterable
        default-first-option
        placeholder="Select Partner"
      >
        <el-option
          v-for="option in users"
          :key="option.id"
          :label="option.name"
          :value="option.id"
        >
        </el-option>
      </el-select>

    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
                  <span class="avatar avatar-sm rounded-circle">
                    <img alt="Image placeholder" src="/img/theme/blank-profile-picture.jpg">
                  </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{user.name}}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-item @click="logout">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { Select, Option } from "element-ui";
import { BaseNav } from '@/components';
import { mapGetters } from 'vuex';
import { FETCH_USER, FETCH_USERS, FETCH_PARTNER } from '@/store/actions.type';
import {AuthService} from '@/common/auth.service';
import { Role } from '@/helpers/role.js';

export default {
  components: {
    BaseNav,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    ...mapGetters(['users', 'user']),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      auth: AuthService,
      role: Role,
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      selectedPartner: null
    };
  },
  mounted () {
    this.fetchUser();
    if (this.auth.hasAnyRole([this.role.Admin])){
      this.fetchUsers();
    }
  },
  watch: {
    selectedPartner: function (val) {
      this.$store.dispatch(FETCH_PARTNER, val);
    }
  },
  methods: {
    fetchUser () {
        this.$store.dispatch(FETCH_USER);
    },
    fetchUsers () {
        this.$store.dispatch(FETCH_USERS);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      AuthService.logout();
      this.$router.push({
        path: '/login'
      })
    }
  }
};
</script>
